import { HttpClient, HttpContext, HttpErrorResponse } from '@angular/common/http';
import { Service, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ResponseApi } from '../../../core/dtos/response-api';
import { HANDLE_HTTP_ERROR_LOCALLY, SKIP_AUTH_TOKEN } from '../../../core/http/http-context-tokens';

const RECURSO = `${environment.apiUrl}/sai/publico/captcha-consulta`;

/** O cabeçalho em que o token do captcha volta na consulta por protocolo. */
export const CABECALHO_CAPTCHA_TOKEN = 'X-Captcha-Token';

/** O cabeçalho com o que o cidadão digitou. */
export const CABECALHO_CAPTCHA_RESPOSTA = 'X-Captcha-Resposta';

/** O cabeçalho com que a API marca o 422 do captcha. */
export const CABECALHO_CAPTCHA_INVALIDO = 'X-Captcha-Invalido';

/** A mesma frase da API: o código vale uma tentativa, e a tela já trouxe outro. */
export const MENSAGEM_CAPTCHA_RECUSADO = 'O código de verificação não confere ou expirou. Digite o novo código.';

export interface CaptchaConsulta {
  token: string;
  /** O PNG em base64, sem o prefixo `data:`. */
  imagem: string;
  validadeSegundos: number;
}

/** O que a consulta leva nos cabeçalhos: o token emitido e o que foi digitado. */
export interface RespostaCaptcha {
  token: string;
  resposta: string;
}

/**
 * O **captcha da consulta por protocolo** (change captcha-consulta-protocolo): a imagem que a API
 * gera, como o `/CaptchaSai/Imagem` do SAI, e o token que a consulta devolve com o código digitado.
 * O código só existe na imagem — a tela nunca o conhece. Sem token de sessão e com o erro local.
 */
@Service()
export class CaptchaConsultaService {
  private readonly http = inject(HttpClient);

  obter(): Observable<CaptchaConsulta> {
    const contexto = new HttpContext().set(HANDLE_HTTP_ERROR_LOCALLY, true).set(SKIP_AUTH_TOKEN, true);

    return this.http
      .get<ResponseApi<CaptchaConsulta>>(RECURSO, { context: contexto })
      .pipe(map((resposta) => resposta.data));
  }
}

/** Os dois cabeçalhos da consulta, com a resposta aparada. */
export function cabecalhosCaptcha(captcha: RespostaCaptcha): Record<string, string> {
  return {
    [CABECALHO_CAPTCHA_TOKEN]: captcha.token,
    [CABECALHO_CAPTCHA_RESPOSTA]: captcha.resposta.trim(),
  };
}

/** O 422 do captcha — pelo cabeçalho, nunca pelo texto. */
export function ehRecusaDoCaptcha(erro: unknown): boolean {
  return (
    erro instanceof HttpErrorResponse &&
    erro.status === 422 &&
    erro.headers?.get(CABECALHO_CAPTCHA_INVALIDO) === 'true'
  );
}
